const COUNTER_ID = 111887091;
const TAG_URL = `https://mc.yandex.ru/metrika/tag.js?id=${COUNTER_ID}`;
const SCRIPT_ATTRIBUTE = 'data-freedom-yandex-metrika';

type MetrikaFunction = ((...args: unknown[]) => void) & { a?: unknown[][]; l?: number };
type MetrikaWindow = Window & {
  ym?: MetrikaFunction;
  [key: `disableYaCounter${number}`]: boolean | undefined;
};

const metrikaWindow = (): MetrikaWindow => window as unknown as MetrikaWindow;

function ensureQueue(): MetrikaFunction {
  const target = metrikaWindow();
  if (target.ym) return target.ym;
  const queue: MetrikaFunction = (...args: unknown[]): void => {
    (queue.a ??= []).push(args);
  };
  queue.l = Date.now();
  target.ym = queue;
  return queue;
}

function removeMetrikaStorage(): void {
  try {
    for (const key of Object.keys(window.localStorage)) {
      if (key.startsWith('_ym')) window.localStorage.removeItem(key);
    }
  } catch {
    // Storage can be unavailable under strict browser privacy policies.
  }

  try {
    const cookieNames = document.cookie.split(';').map((item) => item.slice(0, item.indexOf('=')).trim()).filter((name) => name.startsWith('_ym'));
    const host = window.location.hostname;
    const labels = host.split('.');
    const domains = new Set<string | undefined>([undefined, host, `.${host}`]);
    if (labels.length > 2) domains.add(`.${labels.slice(-2).join('.')}`);
    for (const name of cookieNames) {
      for (const domain of domains) {
        document.cookie = `${name}=; Path=/; Max-Age=0; SameSite=Lax${domain ? `; Domain=${domain}` : ''}`;
      }
    }
  } catch {
    // Cookie cleanup is best-effort when the browser blocks cookie access.
  }
}

export function setYandexMetrikaEnabled(enabled: boolean): void {
  const target = metrikaWindow();
  target[`disableYaCounter${COUNTER_ID}`] = !enabled;

  if (!enabled) {
    target.ym?.(COUNTER_ID, 'destruct');
    document.querySelector<HTMLScriptElement>(`script[${SCRIPT_ATTRIBUTE}]`)?.remove();
    removeMetrikaStorage();
    return;
  }

  const ym = ensureQueue();
  if (!document.querySelector(`script[${SCRIPT_ATTRIBUTE}]`)) {
    const script = document.createElement('script');
    script.async = true;
    script.src = TAG_URL;
    script.setAttribute(SCRIPT_ATTRIBUTE, 'true');
    document.head.append(script);
  }
  ym(COUNTER_ID, 'init', {
    ssr: true,
    webvisor: true,
    clickmap: true,
    ecommerce: 'dataLayer',
    referrer: document.referrer,
    url: window.location.href,
    accurateTrackBounce: true,
    trackLinks: true,
  });
}
